const updates = [
  {
    time: '今天 14:32',
    title: '某知名演员被曝税务问题，工作室紧急回应',
    tag: '突发',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '今天 12:15',
    title: '某综艺节目导演组集体辞职，节目或将停播',
    tag: '独家',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '今天 09:48',
    title: '某女团成员被拍到与男星牵手逛街，恋情曝光',
    tag: '热',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '昨天 22:30',
    title: '某直播平台头部主播因不当言论被封禁30天',
    tag: '快讯',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '昨天 18:05',
    title: '某歌手新专辑销量造假疑云，粉丝晒单引质疑',
    tag: '争议',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '昨天 14:20',
    title: '某品牌官宣更换代言人，前任代言人发文暗讽',
    tag: '追踪',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '昨天 10:00',
    title: '某知名导演新片发布会现场遭前员工举牌抗议',
    tag: '现场',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">实时快讯</h2>
          <p className="text-sm text-foreground-500">24小时不间断追踪最新八卦动态</p>
        </div>

        <div className="relative pl-6 md:pl-8">
          <div className="absolute left-0 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updates.map((u, i) => (
              <div key={i} className="relative pl-5 md:pl-7 cursor-pointer group">
                <div className="absolute left-[-26px] md:left-[-34px] top-1.5 w-3 h-3 rounded-full border-2 border-primary-500 bg-background-50 group-hover:bg-primary-500 transition-colors"></div>

                <div className="bg-background-100 rounded-lg p-4 transition-all duration-200 hover:scale-[1.01]">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{u.time}</span>
                    <span className={`px-2 py-0.5 rounded text-xs font-semibold whitespace-nowrap ${u.tagColor}`}>{u.tag}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug">{u.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}